var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxUnauthorizedAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5003 14.5827C17.5003 16.1935 16.1945 17.4993 14.5837 17.4993C12.9728 17.4993 11.667 16.1935 11.667 14.5827C11.667 12.9719 12.9728 11.666 14.5837 11.666C16.1945 11.666 17.5003 12.9719 17.5003 14.5827Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66699 9.16602H18.3337",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 9.16732L3.84451 7.12131C4.29924 5.30241 4.5266 4.39296 5.20475 3.86347C5.88291 3.33398 6.82034 3.33398 8.69522 3.33398H11.3041C13.179 3.33398 14.1164 3.33398 14.7946 3.86347C15.4728 4.39296 15.7001 5.30241 16.1548 7.12131L16.6663 9.16732",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 14.5827C8.33333 16.1935 7.0275 17.4993 5.41667 17.4993C3.80584 17.4993 2.5 16.1935 2.5 14.5827C2.5 12.9719 3.80584 11.666 5.41667 11.666C7.0275 11.666 8.33333 12.9719 8.33333 14.5827Z",
    stroke: "#2058E7",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 14.5832L8.88164 14.3089C9.58546 13.9569 10.4139 13.9569 11.1177 14.3089L11.6663 14.5832",
    stroke: "#2058E7",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxUnauthorizedAccess);
export default __webpack_public_path__ + "static/media/BoxUnauthorizedAccess.59284ae825edb7671f4f46a021af5773.svg";
export { ForwardRef as ReactComponent };